import PropTypes from "prop-types";
import { useContext } from "react";
import { CartContext } from "lib/cartContext";

import Container from "components/shared/container/Container";
import UspTicker from "components/shared/uspTicker/UspTicker";
import { StickyStyled, UspsContainer } from "./Sticky.styled";
import Summary from "../summary/Summary";

function Sticky({ quantity, subtotal, onSubmit, buttonDisabled }) {
    const { showOverlay } = useContext(CartContext);

    return (
        <StickyStyled>
            <Container>
                <Summary
                    packageQuantity={quantity}
                    subtotal={subtotal}
                    showOverlay={showOverlay}
                    onSubmit={onSubmit}
                    isButtonDisabled={buttonDisabled}
                >
                    <UspsContainer>
                        <UspTicker type="smaller" />
                    </UspsContainer>
                </Summary>
            </Container>
        </StickyStyled>
    );
}
Sticky.defaultProps = {
    quantity: 0,
    subtotal: 0
};

Sticky.propTypes = {
    quantity: PropTypes.number,
    subtotal: PropTypes.number,
    onSubmit: PropTypes.func.isRequired,
    buttonDisabled: PropTypes.bool.isRequired
};

export default Sticky;
